export const DELETE_LIST = {
  TODO: {
    TITLE: 'TODOを削除',
    DESC: 'すべてのTODOを削除します。',
  },
  LOG: {
    TITLE: '操作履歴を削除',
    DESC: 'すべての操作履歴を削除します。',
  },
  ALL:  {
    TITLE: 'すべてを削除',
    DESC: 'すべてのTODO、操作履歴を削除します。',
  },
}